import { render, staticRenderFns } from "./SimpleStepper.vue?vue&type=template&id=22e9bd9c&scoped=true&"
import script from "./SimpleStepper.vue?vue&type=script&lang=js&"
export * from "./SimpleStepper.vue?vue&type=script&lang=js&"
import style0 from "./SimpleStepper.vue?vue&type=style&index=0&id=22e9bd9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e9bd9c",
  null
  
)

export default component.exports